import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, alpha, CircularProgress } from "@mui/material";
import CardCertificados from "./CardCertificados";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";

const CertificadosPages = () => {
    const [infoCertificados, setInfoCertificados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, 'pageinfocertificadocalocho'),
            (snapshot) => {
                const arregloInfoCertificado = snapshot.docs.map((docInfoCertificado) => {
                    return {...docInfoCertificado.data(), id: docInfoCertificado.id};
                });
                setInfoCertificados(arregloInfoCertificado);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );
        return () => unsubscribe();
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (infoCertificados.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % infoCertificados.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [infoCertificados.length]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
        );
    }

    if (infoCertificados.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        <Box sx={(theme) => ({
            width: '100%',
            backgroundImage:
              theme.palette.mode === 'light'
                ? 'linear-gradient(180deg, #5d0303, #FFF)'
                : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            padding: { xs: 2, sm: 4, md: 8 }, 
        })}>
                <Grid key={infoCertificados[currentIndex].id} container alignItems="center" justifyContent="center" sx={{
                    p: { xs: 2, sm: 4, md: 6 },
                    m: { xs: 0, sm: 3, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: { xs: '100%', sm: '80%', md: '100%' },
                    mx: 'auto'
                }}>
                    <Typography component="h3" textAlign="center" sx={{
                        marginBottom: { xs: '2%', sm: '3%' },
                        marginTop: { xs: '16%', sm: '3%' },
                        textAlign: 'center',
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
                    }} variant="h3">
                        {infoCertificados[currentIndex].titulo}
                    </Typography>
                    <Typography component="h1" textAlign="center" sx={{
                        marginBottom: { xs: '1%', sm: '2%' },
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                    }} variant="subtitle1">
                        {infoCertificados[currentIndex].subtitulo}
                    </Typography>
                    <Typography component="h1" textAlign="center" sx={{
                        marginBottom: { xs: '1%', sm: '2%' },
                        textAlign: 'center',
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }
                    }} variant="subtitle1">
                        {infoCertificados[currentIndex].descripcion}
                    </Typography>
                </Grid>
            <CardCertificados />
        </Box>
    );
}

export default CertificadosPages;